import { IApplicationState } from '../../../../../../types/types';
import { TCommentId } from '../../../../../../store/model/card/types/IComment';

export const getEditCommentId = (state: IApplicationState): TCommentId => {
    return state.comments.editCommentId;
}
